import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import dahlia1 from './assets/images/dahlia/dahlia1.jpg';
import dahlia2 from './assets/images/dahlia/dahlia2.jpg';
import dahlia3 from './assets/images/dahlia/dahlia3.jpg';
import dahlia4 from './assets/images/dahlia/dahlia4.jpg';
import dahlia5 from './assets/images/dahlia/dahlia5.jpg';
import dahlia6 from './assets/images/dahlia/dahlia6.jpg';
import dahlia7 from './assets/images/dahlia/dahlia7.jpg';
import dahlia8 from './assets/images/dahlia/dahlia8.jpg';
import dahlia9 from './assets/images/dahlia/dahlia9.jpg';
import dahlia10 from './assets/images/dahlia/dahlia10.jpg';
import dahlia11 from './assets/images/dahlia/dahlia11.jpg';
import dahlia12 from './assets/images/dahlia/dahlia12.jpg';
import dahlia13 from './assets/images/dahlia/dahlia13.jpg';
import dahlia14 from './assets/images/dahlia/dahlia14.jpg';
import dahlia15 from './assets/images/dahlia/dahlia15.jpg';
import dahlia16 from './assets/images/dahlia/dahlia16.jpg';
import rainbow from './assets/images/rainbow.svg';

const photos = [
    { src: dahlia1, ...WidePhoto },
    { src: dahlia2, ...WidePhoto },
    { src: dahlia3, ...WidePhoto },
    { src: dahlia4, ...TallPhoto },
    { src: dahlia5, ...WidePhoto },
    { src: dahlia6, ...SquarePhoto },
    { src: dahlia7, ...TallPhoto },
    { src: dahlia8, ...WidePhoto },
    { src: dahlia9, ...WidePhoto },
    { src: dahlia10, ...WidePhoto },
    { src: dahlia11, ...WidePhoto },
    { src: dahlia12, ...WidePhoto },
    { src: dahlia13, ...WidePhoto },
    { src: dahlia14, ...WidePhoto },
    { src: dahlia15, ...WidePhoto },
    { src: dahlia16, ...WidePhoto },
];

const Dahlia = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="male">
                <span className="rainbow-dog">
                    <i className="far fa-venus"></i>
                    <img src={rainbow} alt="rainbow icon" className="rainbow-icon large" />
                    Dahlia
                </span>
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>GCH BBPIS LUNANOVAS DAHLIA FILHA DA FLOR CGN WWD</td>
                        <td><span className="title">Owner</span>Carolynne Issa</td>
                        <td width="100px"><span className="title">CKC Registration</span>#BA544111</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>AM/CAN CH TSAVO'S MACKINAC LIGHT OF DELSUR</td>
                        <td><span className="title">Dam</span>CH LUNANOVA MAIAS FLOR DA LAVANDA AWD CGN</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>Wavy</td>
                        <td><span className="title">Coat Colour</span>BROWN WITH WHITE MARKINGS</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>EXCELLENT</td>
                        <td><span className="title">CERF</span>NORMAL</td>
                        <td><span className="title">Optigen PRA</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">Optigen IC</span>normal</td>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )

}
export default Dahlia;
